module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/water@2x_57fb82.jpg";